import React, { useState } from "react";
import { Col, Row, Card, Accordion, Button } from "react-bootstrap";
import { Input } from "../../../../../library/input";
import { Label } from "../../../../../library/label";

const Index = ({ companyObject, setCompanyObject }) => {
  const [activeTab, setActiveTab] = useState("0");

  return (
    <div className="company-details-container">
      <Accordion
        className="company-accordion"
        defaultActiveKey="0"
        activeKey={activeTab}
      >
        <Card className="single-card top">
          <Card.Header className="card-header">
            <Accordion.Toggle
              className="card-toggle"
              as={Button}
              variant="link"
              eventKey="0"
              onClick={() => setActiveTab("0")}
            >
              Generelt <i class="fad fa-chevron-down"></i>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body className="card-body">
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Bedriftsnavn *
                  </Label>
                  <Input
                    value={
                      companyObject.general && companyObject.general.name
                        ? companyObject.general.name
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        general: {
                          ...companyObject.general,
                          name: e.target.value,
                        },
                      })
                    }
                    placeholder="Bedriftsnavn"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Bransje *
                  </Label>
                  <Input
                    value={
                      companyObject.general && companyObject.general.industry
                        ? companyObject.general.industry
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        general: {
                          ...companyObject.general,
                          industry: e.target.value,
                        },
                      })
                    }
                    placeholder="Bransje"
                    type="text"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card className="single-card">
          <Card.Header className="card-header">
            <Accordion.Toggle
              className="card-toggle"
              as={Button}
              variant="link"
              eventKey="1"
              onClick={() => setActiveTab("1")}
            >
              Kontaktpunkter <i class="fad fa-chevron-down"></i>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="1">
            <Card.Body className="card-body">
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    E-postadresse *
                  </Label>
                  <Input
                    value={
                      companyObject.contact && companyObject.contact.email
                        ? companyObject.contact.email
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        contact: {
                          ...companyObject.contact,
                          email: e.target.value,
                        },
                      })
                    }
                    placeholder="E-postadresse"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Telefon
                  </Label>
                  <Input
                    international={true}
                    countryCallingCodeEditable={false}
                    format="phone"
                    value={
                      companyObject.contact && companyObject.contact.phone
                        ? companyObject.contact.phone
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        contact: {
                          ...companyObject.contact,
                          phone: e,
                        },
                      })
                    }
                    placeholder="Telefon"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Hjemmeside
                  </Label>
                  <Input
                    value={
                      companyObject.contact && companyObject.contact.website
                        ? companyObject.contact.website
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        contact: {
                          ...companyObject.contact,
                          website: e.target.value,
                        },
                      })
                    }
                    placeholder="Hjemmeside"
                    type="text"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card className="single-card">
          <Card.Header className="card-header">
            <Accordion.Toggle
              className="card-toggle"
              as={Button}
              variant="link"
              eventKey="2"
              onClick={() => setActiveTab("2")}
            >
              Sosiale medier <i class="fad fa-chevron-down"></i>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="2">
            <Card.Body className="card-body">
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Facebook
                  </Label>
                  <Input
                    value={
                      companyObject.social && companyObject.social.facebook
                        ? companyObject.social.facebook
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        social: {
                          ...companyObject.social,
                          facebook: e.target.value,
                        },
                      })
                    }
                    placeholder="Facebook"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Twitter
                  </Label>
                  <Input
                    value={
                      companyObject.social && companyObject.social.twitter
                        ? companyObject.social.twitter
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        social: {
                          ...companyObject.social,
                          twitter: e.target.value,
                        },
                      })
                    }
                    placeholder="Twitter"
                    type="text"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card className="single-card">
          <Card.Header className="card-header">
            <Accordion.Toggle
              className="card-toggle"
              as={Button}
              variant="link"
              eventKey="3"
              onClick={() => setActiveTab("3")}
            >
              Addresse <i class="fad fa-chevron-down"></i>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="3">
            <Card.Body className="card-body">
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Gate
                  </Label>
                  <Input
                    value={
                      companyObject.address && companyObject.address.street
                        ? companyObject.address.street
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        address: {
                          ...companyObject.address,
                          street: e.target.value,
                        },
                      })
                    }
                    placeholder="Gate"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Postnummer
                  </Label>
                  <Input
                    format="postal"
                    value={
                      companyObject.address && companyObject.address.postalCode
                        ? companyObject.address.postalCode
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        address: {
                          ...companyObject.address,
                          postalCode: e.target.value,
                        },
                      })
                    }
                    placeholder="Postnummer"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Poststed
                  </Label>
                  <Input
                    value={
                      companyObject.address && companyObject.address.city
                        ? companyObject.address.city
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        address: {
                          ...companyObject.address,
                          city: e.target.value,
                        },
                      })
                    }
                    placeholder="Poststed"
                    type="text"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default Index;
